var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M478.2,280.2v176.7H375.6v-165c0-41.5-14.8-69.7-51.9-69.7c-28.4,0-45.1,19.1-52.6,37.5\n\tc-2.7,6.6-3.5,15.9-3.5,25v172.2H165.2c0,0,1.4-279.3,0-308.3h102.4v43.7c-0.1,0.4-0.4,0.7-0.6,1.1h0.6v-1.1\n\tc13.7-21,37.9-50.9,92.4-50.9C427.7,141.4,478.2,185.4,478.2,280.2z M58,0C23,0,0,23,0,53.3c0,29.5,22.3,53.3,56.7,53.3h0.6\n\tc35.8,0,58-23.8,58-53.3C114.6,23,93.1,0,58,0z M6.1,456.9h102.5V148.6H6.1V456.9z"}));
}

SocialLinkedin.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 478.2 456.9","enableBackground":"new 0 0 478.2 456.9","xmlSpace":"preserve"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
